const KEY_HEADER = {
  LUYEN_TAP: 'LUYEN_TAP',
  SACH_DIEN_TU: 'SACH_DIEN_TU',
  THU_VIEN_SO: 'THU_VIEN_SO',
  TIEN_ICH: 'TIEN_ICH',
  KIEN_THUC: 'KIEN_THUC',
  PROFILE: 'PROFILE',
  NOTIFICATION: 'NOTIFICATION',
};
export const MEDIA_TYPE = {
  JSON: 'application/json',
  FORM_URLENCODE: 'application/x-www-form-urlencoded',
};

export const TYPE_TICKET = {
  TYPE_TICKET_PRACTICE: 'POINT',
  TYPE_TICKET_QUESTION: 'QUESTION',
};

export const IDENTITY_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const TYPE_COLABORATOR = {
  COLABORATOR: 'colaborator',
  EXPERT: 'expert',
};

export const STATUS_RATE = {
  GOOD: 'GOOD',
  NOT_GOOD: 'NOTGOOD',
};

export const ACTION_RESPONSE_REPORT = {
  AGREE: 'AGREE',
  RESPONSE: 'RESPONSE',
};

export const QA_TICKET_STATUS = {
  OPEN: 'open',
  PROCESS: 'process',
  CLOSE: 'close',
  REPORT: 'report',
};

export const QA_TICKET_DESCRIPTION = {
  ['open']: 'Đang mở',
  ['process']: 'Đang xử lý',
  ['close']: 'Đã xử lý',
  ['report']: 'Báo cáo',
};

export const FEED_BACK_TYPE = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};

export const BOOKING_SUB_STATUS = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};
export const getStatusClass = (status?: string) => {
  switch (status) {
    case QA_TICKET_STATUS.OPEN:
    case FEED_BACK_TYPE.OPEN:
      return 'text-green-500'; // Màu xanh lá cho trạng thái OPEN
    case QA_TICKET_STATUS.PROCESS:
      return 'text-yellow-500'; // Màu vàng cho trạng thái PROCESS
    case QA_TICKET_STATUS.CLOSE:
    case FEED_BACK_TYPE.CLOSE:
      return 'text-red-500'; // Màu đỏ cho trạng thái CLOSE
    case QA_TICKET_STATUS.REPORT:
      return 'text-blue-500 underline cursor-pointer'; // Màu xanh dương cho trạng thái REPORT
    default:
      return 'text-gray-500'; // Màu xám mặc định cho trạng thái không xác định
  }
};
export const TYPE_RATE = {
  RATE: 'RATE',
  REPORT: 'REPORT',
};

const ROLE_NAME = {
  ROLE_TEACHER: 'ROLE_TEACHER',
  ROLE_STUDENT: 'ROLE_STUDENT',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_CTV: 'ROLE_CTV',
  ROLE_EXPERT: 'ROLE_EXPERT',
  ROLE_COMPILER: 'ROLE_COMPILER',
  ROLE_MASTER_COMPILER: 'ROLE_MASTER_COMPILER',
};

const ROLE_DESCRIPTIONS = {
  [ROLE_NAME.ROLE_CTV]: 'Công tác viên',
  [ROLE_NAME.ROLE_EXPERT]: 'Chuyên gia',
  [ROLE_NAME.ROLE_STUDENT]: 'Học sinh',
  [ROLE_NAME.ROLE_ADMIN]: 'Admin',
  [ROLE_NAME.ROLE_COMPILER]: 'Biên tập',
  [ROLE_NAME.ROLE_MASTER_COMPILER]: 'Tổng biên tập',
};

export const TYPE_PACKAGE = {
  TICKET: 'TICKET',
  MONTH: 'MONTH',
};

const childrenMobiles = (key: number) => [
  {
    label: 'Mầm non',
    key: `Mầm non ${key}`,
    url: '/sach-dien-tu?classes=60',
  },
  {
    label: 'Tiểu học',
    key: `Tiểu học ${key}`,
    children: [
      {
        label: 'Lớp 1',
        key: `Lớp 1 ${key}`,
        url: '/sach-dien-tu?classes=1',
      },
      {
        label: 'Lớp 2',
        key: `Lớp 2 ${key}`,
        url: '/sach-dien-tu?classes=2',
      },
      {
        label: 'Lớp 3',
        key: `Lớp 3 ${key}`,
        url: '/sach-dien-tu?classes=3',
      },
      {
        label: 'Lớp 4',
        key: `Lớp 4 ${key}`,
        url: '/sach-dien-tu?classes=4',
      },
      {
        label: 'Lớp 5',
        key: `Lớp 5 ${key}`,
        url: '/sach-dien-tu?classes=5',
      },
    ],
  },
  {
    label: 'Trung học cơ sở',
    key: `Trung học cơ sở ${key}`,
    children: [
      {
        label: 'Lớp 6',
        key: `Lớp 6 ${key}`,
        url: '/sach-dien-tu?classes=6',
      },
      {
        label: 'Lớp 7',
        key: `Lớp 7 ${key}`,
        url: '/sach-dien-tu?classes=7',
      },
      {
        label: 'Lớp 8',
        key: `Lớp 8 ${key}`,
        url: '/sach-dien-tu?classes=8',
      },
      {
        label: 'Lớp 9',
        key: `Lớp 9 ${key}`,
        url: '/sach-dien-tu?classes=9',
      },
    ],
  },
  {
    label: 'Trung học phổ thông',
    key: `Trung học phổ thông ${key}`,
    children: [
      {
        label: 'Lớp 10',
        key: `Lớp 10 ${key}`,
        url: '/sach-dien-tu?classes=10',
      },
      {
        label: 'Lớp 11',
        key: `Lớp 11 ${key}`,
        url: '/sach-dien-tu?classes=11',
      },
      {
        label: 'Lớp 12',
        key: `Lớp 12 ${key}`,
        url: '/sach-dien-tu?classes=12',
      },
    ],
  },
];
const items = [
  {
    label: 'Trang chủ',
    key: '/',
  },

  {
    label: 'Học liệu số',
    key: 'Học liệu số',
    children: [
      {
        label: 'Sách giáo khoa',
        key: 'Sách giáo khoa',
        children: childrenMobiles(1),
      },
      {
        label: 'Sách bài tập',
        key: 'Sách bài tập',
        children: childrenMobiles(2),
      },
      {
        label: 'Sách giáo viên',
        key: 'Sách giáo viên',
        children: childrenMobiles(3),
      },
      {
        label: 'Sách ngoại ngữ',
        key: 'Sách ngoại ngữ',
        children: childrenMobiles(4),
      },
    ],
  },
  {
    label: 'Hoạt động',
    key: 'Hoạt động',
    children: [
      {
        label: 'Luyện tập',
        key: '/luyen-tap?lop=60',
        url: '/luyen-tap?lop=60',
      },
      {
        label: 'Luyện đề',
        key: '/luyen-de',
        url: '/luyen-de',
      },
      {
        label: 'Hướng dẫn thi',
        key: 'Hướng dẫn thi',
        url: '/sach-dien-tu?classes=0',
      },
    ],
  },
  {
    label: 'Thư viện số',
    key: 'Thư viện số',
    children: [
      {
        label: 'Học liệu điện tử',
        key: '/thu-vien-so',
      },
      {
        label: 'Bài giảng điện tử',
        key: '/thu-vien-so?tab=2',
      },
      {
        label: 'Học chủ động',
        key: '/thu-vien-so?tab=3',
      },
    ],
  },
  {
    label: 'Tiện ích',
    key: 'Tiện ích',
  },
  {
    label: 'Tin tức',
    key: 'Tin tức',
  },
];

const highPractice = () => {
  return [
    {
      key: '1',
      label: 'Đánh giá kiến thức',
      url: '/on-luyen-thpt/danh-gia-kien-thuc',
    },
    {
      key: '2',
      label: 'Luyện đề',
      url: '/on-luyen-thpt/luyen-de',
    },
    {
      key: '3',
      label: 'Hỏi đáp',
      url: '/on-luyen-thpt/hoi-dap',
    },
  ];
};

const levels = () => {
  return [
    {
      key: '60',
      label: 'Mầm non',
      class: [],
    },
    {
      key: '1',
      label: 'Tiểu học',
      class: [
        {
          key: '1',
          label: 'Lớp 1',
        },
        {
          key: '2',
          label: 'Lớp 2',
        },
        {
          key: '4',
          label: 'Lớp 3',
        },
        {
          key: '8',
          label: 'Lớp 4',
        },
        {
          key: '7',
          label: 'Lớp 5',
        },
      ],
    },
    {
      key: '2',
      label: 'Trung học cơ sở',
      class: [
        {
          key: '10',
          label: 'Lớp 6',
        },
        {
          key: '11',
          label: 'Lớp 7',
        },
        {
          key: '12',
          label: 'Lớp 8',
        },
        {
          key: '13',
          label: 'Lớp 9',
        },
      ],
    },
    {
      key: '3',
      label: 'Trung học phổ thông',
      class: [
        {
          key: '14',
          label: 'Lớp 10',
        },
        {
          key: '15',
          label: 'Lớp 11',
        },
        {
          key: '16',
          label: 'Lớp 12',
        },
      ],
    },
  ];
};

const subMenuDigital = [
  {
    key: '1',
    label: 'Sách giáo khoa',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '3',
    label: 'Sách bài tập',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '2',
    label: 'Sách giáo viên',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '4',
    label: 'Sách ngoại ngữ',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
];
const subMenuWork = [
  {
    key: '1',
    label: 'Luyện tập',
    url: '/luyen-tap?lop=1',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '2',
    label: 'Ôn Luyện THPT',
    url: '',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
];
const subMenuLibrary = [
  {
    key: '1',
    label: 'Học liệu điện tử',
    url: '/thu-vien-so',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '2',
    label: 'Bài giảng điện tử',
    url: '/thu-vien-so?tab=2',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '3',
    label: 'Học chủ động',
    url: '/thu-vien-so?tab=3',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
];
const subMenuKnowledge = [
  {
    key: '1',
    label: 'Tin nổi bật',
    url: '/tin-tuc',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '2',
    label: 'Tin giáo dục',
    url: '/tin-tuc/chuyen-muc-tin-tuc',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  {
    key: '3',
    label: 'Hoạt động',
    url: '/tin-tuc/chuyen-muc-tin-tuc',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
  // {
  //     key: '4',
  //     label: 'Kiến thức',
  //     url: '/tin-tuc/chuyen-muc-tin-tuc',
  // },
];

const subMenuUtilities = [
  {
    key: '1',
    label: 'Lớp học',
    url: '/lop-hoc',
    roleName: ROLE_NAME.ROLE_TEACHER,
  },
  {
    key: '2',
    label: 'Soạn tài liệu',
    url: '/soan-tai-lieu',
    roleName: ROLE_NAME.ROLE_ADMIN,
  },
];
const Authorization =
  'Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJ0SDJMQVk4eGRMRzZmMnp1X3ZSTU1OcW9Pa3BrZDVEa1B1cGtucWpObi1VIn0.eyJleHAiOjE3MTEzNDcwMjUsImlhdCI6MTcxMTM0NjcyNSwianRpIjoiOGNlNWMyMWItZTllZi00NGFjLWI1YWItZDcwZWQyMjZjOWZhIiwiaXNzIjoiaHR0cDovL2tleWNsb2FrLXVhdC5odHMuY29tL3JlYWxtcy9odHMyLjAiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiMjE3MDA4YjAtZDQwMC00YjAxLWIxMjYtNDBiYjZjOGEzM2IyIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiSFRTMi4wIiwic2Vzc2lvbl9zdGF0ZSI6ImU0ZjFjMzBkLWNhNWMtNGE0MS05NzEwLWRmZjA0Mjg5MmEwMyIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiLyoiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIkhPQ19TSU5IIiwib2ZmbGluZV9hY2Nlc3MiLCJkZWZhdWx0LXJvbGVzLWh0czIuMCIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgb2ZmbGluZV9hY2Nlc3MgZW1haWwgcHJvZmlsZSIsInNpZCI6ImU0ZjFjMzBkLWNhNWMtNGE0MS05NzEwLWRmZjA0Mjg5MmEwMyIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6Ik5ndXnhu4VuIFRo4buLIExhbiIsInByZWZlcnJlZF91c2VybmFtZSI6InN0dWRlbnQwMTBAZ21haWwuY29tIiwiZ2l2ZW5fbmFtZSI6Ik5ndXnhu4VuIiwiZmFtaWx5X25hbWUiOiJUaOG7iyBMYW4iLCJlbWFpbCI6InN0dWRlbnQwMTBAZ21haWwuY29tIn0.Fx-dcSFcEoyho2HOPMwFy3Iov_p6xOgZy_DdRBMLxZsFLG-sM96IMDqKEqiDHIuDOAa-jMhZMnqsyMcWOHpYYDgW-YlaF92NDgZUet-vS5cUttA-42TmiNyjxyIU7IvbUFfQkYee_dM-Ve17tewrA4BeeldJgrbaqNOwznlGFTLNXxLDEF8wYovigiIi_Wis3V3BtfBgpRSYgsw17ESst7bqgJhSIoWh7nnu_lgDVLCUdh1QbfAg669wKaoelx0O2aQuCtJJf8LPC8tWROow6G_V3iD9nQea8koQ7265Qzx5Xyx9J6EG84nQxG3JftYp06gQeMyCTbwVatRcGZxCmQ';
const dataBookpractice = [
  { name: 'Luyện tập', type: 2 },
  { name: 'Đọc sách', type: 1 },
];
const dataTime = [
  { name: 'Theo tuần', timeType: 1 },
  { name: 'Theo tháng', timeType: 2 },
  { name: 'Theo năm', timeType: 3 },
];

const listSubject = [
  {
    label: 'Hóa học',
    key: '1',
  },
  {
    label: 'Sinh học',
    key: '2',
  },
  {
    label: 'Toán học',
    key: '3',
  },
];

const listTimeType = [
  {
    label: 'Theo Tuần',
    key: '1',
  },
  {
    label: 'Theo Tháng',
    key: '2',
  },
  {
    label: 'Theo Năm',
    key: '3',
  },
];

export {
  listSubject,
  listTimeType,
  dataTime,
  dataBookpractice,
  Authorization,
  subMenuUtilities,
  subMenuKnowledge,
  KEY_HEADER,
  ROLE_NAME,
  ROLE_DESCRIPTIONS,
  childrenMobiles,
  items,
  highPractice,
  levels,
  subMenuDigital,
  subMenuWork,
  subMenuLibrary,
};
